import moment from 'moment'
import { last, flatten, uniq, range, concat } from 'lodash'

export function getAllLinkedProductIds (crop) {
  const methods = range(1, parseInt(crop[`number_of_methods`]) + 1)
  return uniq(flatten(methods.map(methodID => getAllLinkedProductIdsForMethod(crop, methodID))))
}

export function getAllLinkedProductIdsForMethod (crop, methodID) {
  let productIDs = []
  for (let step = 1; step <= parseInt(crop[`method${methodID}_number_of_actions`]); step++) {
    productIDs = concat(productIDs, getAllLinkedProductIdsForAction(crop, methodID, step))
  }
  return uniq(productIDs)
}

export function getAllLinkedProductIdsForAction (crop, methodID, stepID) {
  let productIDs = []
  let prods = crop[`method${methodID}action${stepID}_linked_products`]
  if (prods) {
    prods = prods.split(';')
    prods.pop()
    const regex = new RegExp(/\[(.*)\]/)
    prods.forEach(prod => {
      if (regex.test(prod) && prod.match(regex).length > 0) {
        productIDs.push(prod.match(/\[(.*)\]/)[1])
      }
    })
  }
  return uniq(productIDs)
}

export function getCropMethodEndDate (crop, methodID, startDate) {
  const numActions = crop[`method${methodID}_number_of_actions`]
  let startDates = [startDate]
  for (let i = 2; i <= numActions; i++) {
    if (crop[`method${methodID}action${i}_period_from`]) {
      startDates.push(moment(crop[`method${methodID}action${i}_period_from`]))
    } else {
      const number = parseFloat(crop[`method${methodID}action${i}_period_number`])
      const period = crop[`method${methodID}action${i}_period_period`]
      const action = parseFloat(crop[`method${methodID}action${i}_period_action`])
      startDates.push(moment(startDates[action - 1]).add(number, period))
    }
  }
  return last(startDates)
}

export function canCultivationStartThatYearFrom (crop, methodID, date) {
  const firstActionPeriod = getCultivationActionPeriod(crop, methodID, 1, date)
  if (firstActionPeriod.to.year() > firstActionPeriod.from.year()) return true
  return date.isSameOrBefore(firstActionPeriod.to) && firstActionPeriod.to.year() === date.year()
}

export function canCropStartThatYearFrom (crop, date) {
  for (let i = 1; i <= crop['number_of_methods']; i++) {
    const firstActionPeriod = getCultivationActionPeriod(crop, i, 1, date)
    if (firstActionPeriod.to.year() > firstActionPeriod.from.year()) return true
    const canActionStart = date.isSameOrBefore(firstActionPeriod.to) && firstActionPeriod.to.year() === date.year()
    if (canActionStart) return true
  }
  return false
}

export function canCultivationStartAt (crop, methodID, date) {
  const firstActionPeriod = getCultivationActionPeriod(crop, methodID, 1)
  return date.isSameOrAfter(firstActionPeriod.from) && date.isSameOrBefore(firstActionPeriod.to)
}

export function canCropStartAt (crop, date) {
  for (let i = 1; i <= crop['number_of_methods']; i++) {
    const firstActionPeriod = getCultivationActionPeriod(crop, i, 1)
    const canStartActionNow = date.isSameOrAfter(firstActionPeriod.from) && date.isSameOrBefore(firstActionPeriod.to)
    if (canStartActionNow) return true
  }
  return false
}

export function getCultivationActionPeriod (crop, methodID, stepID, calculateFrom) {
  const now = calculateFrom || moment()
  const currentYear = now.year()
  const prefix = `method${methodID}action${stepID}`

  var from = crop[`${prefix}_period_from`]
  var to = crop[`${prefix}_period_to`]

  if (!from || !to) {
    return {
      relative: true,
      amount: (crop[`${prefix}_period_number`] || 1),
      period: crop[`${prefix}_period_period`],
      action: crop[`${prefix}_period_action`]
    }
  }

  to = moment(to).year(currentYear)
  from = moment(from).year(currentYear)

  let fromYear = currentYear

  if (now.isBefore(from) && now.isBefore(to)) {
    fromYear = from.isBefore(to) ? currentYear : currentYear - 1
  } else if (now.isAfter(from) && now.isAfter(to)) {
    fromYear = from.isBefore(to) ? currentYear + 1 : currentYear
  }
  let toYear = from.isBefore(to) ? fromYear : fromYear + 1

  from.year(fromYear)
  to.year(toYear)

  return { from, to }
}
